import React from 'react';
import { BaseForeignIdMapModal } from './BaseForeignIdMapModal';
import { useGetExternalOffices, useSetProjectForeignId } from '../../services/foreignService';
import { useQueryClient } from 'react-query';
import { useMessage } from '../../helpers/useMessages';
import { queryEnums } from '../../config/queryEnums';

interface ProjectForeignIdMapModalProps {
    projectId: string;
    open: boolean;
    onClose: () => void;
}

export const ProjectForeignIdMapModal: React.FC<ProjectForeignIdMapModalProps> = ({
    projectId,
    open,
    onClose
}) => {
    const queryClient = useQueryClient();
    const { sendSuccess, sendError } = useMessage();
    const setForeignIdMutation = useSetProjectForeignId();

    // Using external offices as candidates since useGetProjectMappingCandidates doesn't exist
    const { data: externalOffices = [], isLoading, error } = useGetExternalOffices();
    
    // Transform the external offices to have the expected structure
    const candidates = externalOffices.map(office => ({
        foreignId: office.id,
        name: office.name,
        description: office.description || ''
    }));

    const handleSelect = (foreignId: string | number) => {
        setForeignIdMutation.mutate({ 
            projectId, 
            foreignId: foreignId as number 
        }, {
            onSuccess: () => {
                sendSuccess('Project foreign ID set successfully');
                queryClient.invalidateQueries(queryEnums.foreign_unmapped_projects);
                queryClient.invalidateQueries(queryEnums.foreign_mapped_projects);
                onClose();
            },
            onError: (error: any) => {
                sendError(`Failed to set project foreign ID: ${error.message}`);
            }
        });
    };

    return (
        <BaseForeignIdMapModal
            open={open}
            onClose={onClose}
            title="Map Project to External System"
            candidates={candidates}
            isLoading={isLoading}
            error={error as Error}
            onSelect={handleSelect}
        />
    );
}; 